export default {
    apiKey: "AIzaSyBY-bXdn_InYguG9AH3MZR09WdyuS2__AU",
    authDomain: "hermes-28142.firebaseapp.com",
    projectId: "hermes-28142",
    storageBucket: "hermes-28142.appspot.com",
    messagingSenderId: "377435539534",
    appId: "1:377435539534:web:a97149244e32732ef0db1f"
}